import { FilterCriteriaParam } from '@models/CommonParam';
import { PagesConfig } from '@utils/pageConfig/PagesConfigContext';
import { useQuery } from '@tanstack/react-query';
import { exploreKeys } from '@utils/hook/explore/ExploreKeys';
import { getExploreSegmentsStackedChart } from '@services/explore/Explore.service';
import { useEffect, useState } from 'react';
import { StackedChartResp } from '@data-visualization/stacked-chart/Types';
import useStackedChartSorting from '@utils/hook/sorting/UseStackedChartSorting';
import { Filters } from '@utils/pageConfig/Types';

export const useGetStackedChartData = (
  filterCriteriaParam: FilterCriteriaParam,
  pagesConfig: PagesConfig,
  appliedFeatureValues: Filters[],
  isLimitPG?: boolean,
) => {
  const [sortedStackedChartData, setSortedStackedChartData] = useState<StackedChartResp[]>([]);

  const { sortStackedChartRespData } = useStackedChartSorting();

  const { data, isSuccess, isError, isFetching, isLoading } = useQuery({
    queryKey: exploreKeys.segmentStackChart(filterCriteriaParam),
    queryFn: () => getExploreSegmentsStackedChart(filterCriteriaParam),
    enabled: checkIsStackedChartRequestDataReady(filterCriteriaParam, appliedFeatureValues) && !isLimitPG,
    retry: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data) {
      const sortedData = sortStackedChartRespData(data, pagesConfig.sortByOptionsPerformanceAnalysisStackedChart, true);
      setSortedStackedChartData(sortedData);
    }
  }, [data, pagesConfig.sortByOptionsPerformanceAnalysisStackedChart]);

  return {
    data: sortedStackedChartData ?? [],
    isLoading: isLoading && !isLimitPG && isFetching,
    isSuccess,
    isError,
    isFetching,
  };
};

const checkIsStackedChartRequestDataReady = (
  filterCriteriaParam: FilterCriteriaParam,
  appliedFeatureValues: Filters[],
) => {
  const { segmentBy, segmentName, productGroup } = filterCriteriaParam;
  return !!(
    segmentBy &&
    segmentName &&
    productGroup &&
    appliedFeatureValues.find((f) => f.feature === segmentBy) &&
    //temporary fix for segmentby set to country , can be remove if wont happen
    segmentBy !== 'Country' &&
    segmentBy !== segmentName
  );
};
